(function () {

  const SELECTOR = '[data-th-bundle-option]';

const formatMoney = (cents) => {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD'
  }).format(cents / 100);
};

  function initBundleOption(root) {
    if (!root || root.dataset.thBundleInitialised === 'true') return;

    root.dataset.thBundleInitialised = 'true';

    const bundleVariantsScript = root.querySelector('[data-th-bundle-variants]');
    const selectedPrice = root.querySelector('[data-th-selected-price]');
    const selectedPriceLabel = root.querySelector('[data-th-selected-price-label]');

    if (!bundleVariantsScript || !selectedPrice || !selectedPriceLabel) return;

    let bundleVariants = [];

    try {
      bundleVariants = JSON.parse(bundleVariantsScript.textContent || '[]');
    } catch (error) {
      console.error('Bundle variant JSON error:', error);
      bundleVariants = [];
    }

    const getSelectedPurchase = () => {
      return root.querySelector('input[name^="purchase_option_"]:checked')?.value || 'bundle';
    };

    const getSelectedColour = () => {
      const checkedInput = document.querySelector('[name^="options["]:checked');
      if (checkedInput && checkedInput.value) return checkedInput.value;

      const selectInput = document.querySelector('select[name^="options["]');
      if (selectInput && selectInput.value) return selectInput.value;

      const firstCoverSource = root.querySelector('.th-price-source[data-th-price-source="cover"]');
      if (firstCoverSource && firstCoverSource.dataset.option1) return firstCoverSource.dataset.option1;

      const firstBundleSource = root.querySelector('.th-price-source[data-th-price-source="bundle"]');
      if (firstBundleSource && firstBundleSource.dataset.option1) return firstBundleSource.dataset.option1;

      if (bundleVariants.length === 1) return bundleVariants[0].option1;

      return null;
    };

    const getPriceSource = (type) => {
      const colour = getSelectedColour();
      const sources = root.querySelectorAll(`.th-price-source[data-th-price-source="${type}"]`);

      if (!sources.length) return null;

      if (!colour || sources.length === 1) {
        return sources[0];
      }

      for (const source of sources) {
        if (source.dataset.option1 === colour) {
          return source;
        }
      }

      return sources[0];
    };

    const updateVisiblePrice = () => {
  const selectedPurchase = getSelectedPurchase();
  const isTradeCustomer = root.dataset.isTradeCustomer === 'true';
  const discountPercent = parseInt(root.dataset.tradeDiscountPercent || 0, 10);

  if (isTradeCustomer && selectedPurchase === 'bundle') {
    const retailPrice = parseInt(root.dataset.bundleRetailPriceCents || 0, 10);
    const discountedPrice = Math.round(retailPrice - (retailPrice * discountPercent / 100));

    selectedPrice.innerHTML = `
      <span class="th-bundle-retail-price">
        ${formatMoney(retailPrice)}
      </span>

      <span class="th-bundle-trade-price">
        ${formatMoney(discountedPrice)}
      </span>

      <span class="th-bundle-trade-note">
        TRADE PRICE - ${discountPercent}% OFF
      </span>
    `;

    selectedPriceLabel.innerHTML = '';

    return;
  }

  const source = getPriceSource(selectedPurchase);

  if (!source) return;

  const sourceHtml = source.innerHTML.trim();

  if (sourceHtml) {
    selectedPrice.innerHTML = sourceHtml;

    if (isTradeCustomer && discountPercent > 0) {
      selectedPrice.innerHTML += `
        <span class="th-bundle-trade-note">
          TRADE PRICE - ${discountPercent}% OFF
        </span>
      `;
    }
  }

  selectedPriceLabel.textContent = '';
};

    const forcePriceRefresh = () => {
      updateVisiblePrice();

      setTimeout(updateVisiblePrice, 100);
      setTimeout(updateVisiblePrice, 300);
      setTimeout(updateVisiblePrice, 700);
      setTimeout(updateVisiblePrice, 1200);
      setTimeout(updateVisiblePrice, 2000);
      setTimeout(updateVisiblePrice, 3500);
    };

    const getActiveBundleVariant = () => {
      const colour = getSelectedColour();

      if (bundleVariants.length === 1) {
        return bundleVariants[0];
      }

      return bundleVariants.find((variant) => variant.option1 === colour) || bundleVariants[0];
    };

    const getAddButton = () => {
      return (
        document.querySelector('button[name="add"].add-to-cart-button') ||
        document.querySelector('button.add-to-cart-button[name="add"]') ||
        document.querySelector('button[id^="BuyButtons-ProductSubmitButton-"]') ||
        document.querySelector('add-to-cart-component button[name="add"]') ||
        document.querySelector('button[name="add"]') ||
        document.querySelector('button[type="submit"]')
      );
    };

    const bindBundleHandler = () => {
      const addButton = getAddButton();

      if (!addButton || addButton.dataset.thBundleBound === 'true') return;

      addButton.dataset.thBundleBound = 'true';

      addButton.addEventListener(
        'click',
        function (event) {
          if (getSelectedPurchase() !== 'bundle') return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          const match = getActiveBundleVariant();

          if (!match || !match.id) {
            alert('No matching bundle variant found');
            return false;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: match.id,
              quantity: 1
            })
          })
            .then((response) => response.json())
            .then(() => {
              window.location.href = '/cart';
            })
            .catch((error) => {
              console.error('Bundle add error:', error);
            });

          return false;
        },
        true
      );
    };

    root.querySelectorAll('input[name^="purchase_option_"]').forEach((input) => {
      input.addEventListener('change', forcePriceRefresh);
    });

    document.addEventListener('change', function (event) {
      if (
        event.target.matches('[name^="options["]') ||
        event.target.matches('select[name^="options["]')
      ) {
        forcePriceRefresh();
      }
    });

    const observer = new MutationObserver(() => {
      updateVisiblePrice();
    });

    root.querySelectorAll('.th-price-source').forEach((source) => {
      observer.observe(source, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true
      });
    });

    forcePriceRefresh();

    bindBundleHandler();
    setTimeout(bindBundleHandler, 500);
    setTimeout(bindBundleHandler, 1500);
    setTimeout(bindBundleHandler, 3000);
  }

  function initAllBundleOptions() {
    document.querySelectorAll(SELECTOR).forEach(initBundleOption);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBundleOptions);
  } else {
    initAllBundleOptions();
  }

  document.addEventListener('shopify:section:load', initAllBundleOptions);
  function forceUppercaseOffText() {
  document.querySelectorAll('product-price, product-price *, .price, .price *').forEach((el) => {
    if (el.childNodes && el.childNodes.length) {
      el.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('off')) {
          node.textContent = node.textContent.replace(/off/g, 'OFF');
        }
      });
    }
  });
}

forceUppercaseOffText();
setTimeout(forceUppercaseOffText, 300);
setTimeout(forceUppercaseOffText, 1000);
setTimeout(forceUppercaseOffText, 2500);
})();